import { PopupListControl } from './popup_list_control.js';

class PopupButtonControl extends PopupListControl {
  initialize() {
    super.initialize();

    this.boxElement.setAttribute('tabindex', -1);
    this.boxElement.addEventListener('blur', this.onBlur.bind(this), false);
    this.boxElement.addEventListener(
      'keydown',
      this.onKeyDown.bind(this),
      false
    );
    this.boxElement.addEventListener('click', this.onClick.bind(this), false);
  }

  static properties = {
    img: {
      attribute: true,
      set(v) {
        this.imageButton.src = v;
      },
    },
    label: {
      attribute: true,
      set(v) {
        this.labelElement.innerHTML = v;
      },
    },
    name: {
      attribute: true,
      set(v) {
        this.imageButton.title = v;
      },
    },
  };

  onClick() {
    this.open = !this.open;
  }

  static tagName = 'popup-button-control';
  static boxLabelMarkup = '';

  static get boxMarkup() {
    return `
      <img class='autocomplete-button'>
      <span>${this.boxLabelMarkup}</span>
    `;
  }

  static get selectors() {
    return Object.assign(
      {
        Label: `${PopupListControl.selectors.Box} > span`,
        ImageButton: `${PopupListControl.selectors.Box} > img.autocomplete-button`,
      },
      super.selectors
    );
  }

  static get elements() {
    return {
      imageButton: this.selectors.ImageButton,
      labelElement: this.selectors.Label,
    };
  }
}

PopupButtonControl.defineCustomElement();

export { PopupButtonControl };
